export default function generator(_ref) {
  var breakpoints = _ref.breakpoints,
      spacing = _ref.spacing,
      colors = _ref.colors;
  return {
    reportBorder: '1px solid lightgray',
    masteryColor: colors.shamrock,
    outcomeLabelsSpacing: '0.5rem',
    outcomePickerItemPadding: '0.5rem',
    outcomeTagsSpacing: '0.75rem',
    averageColor: colors.electric,
    checkboxLabelLeftPadding: '0.5rem',
    checkboxDescriptionLeftPadding: '2.25rem' // checkboxLabelLeftPadding + CheckboxFacade/facadeSizeMedium + CheckboxFacade/marginRight

  };
}